
import { GetExeImg, UploadFile } from "../request";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { sizhenMixin } from "../mixins/sizhenMixin";
import { getOptions } from "../common";
import SubTitle from "./title-sub.vue";
import Title from "./title.vue";
@Component({
  components: {
    Title,
    SubTitle,
  },
})
export default class Name extends mixins(sizhenMixin) {
  @Prop()
  private content: any; // 整个content数据
  @Watch("content", { immediate: true })
  private contentChange() {
    if (this.content) {
      this.cContent = JSON.parse(JSON.stringify(this.content));
      // 处理数据
      if (this.cContent.report) {
        if (
          (this.cContent.report["左手脉象信息输出"] &&
            this.cContent.report["左手脉象信息输出"]["脉名"] == "其它脉") ||
          (this.cContent.report["右手脉象信息输出"] &&
            this.cContent.report["右手脉象信息输出"]["脉名"] == "其它脉")
        ) {
          if (
            this.cContent.report["左手脉象信息输出"] &&
            this.cContent.report["左手脉象信息输出"]["脉名"] == "其它脉"
          ) {
            this.cContent.report["左手脉象信息输出"]["脉名"] = "大脉";
          }
          if (
            this.cContent.report["右手脉象信息输出"] &&
            this.cContent.report["右手脉象信息输出"]["脉名"] == "其它脉"
          ) {
            this.cContent.report["右手脉象信息输出"]["脉名"] = "大脉";
          }
          this.$emit(
            "updateContent",
            JSON.parse(JSON.stringify(this.cContent))
          );
          setTimeout(() => {
            // 保存
            this.$emit("save");
          }, 200);
        }
        this.$forceUpdate();
      }
    }
  }
  @Prop()
  private index: any; // 当前题目的索引
  private indexChange() {
    this.templateIndex = this.index;
  }
  @Prop()
  private data: any; // 题目的数据
  @Watch("data", { immediate: true })
  private dataChange() {
    if (this.data) {
      this.c = JSON.parse(JSON.stringify(this.data));
      if (!this.c.value) {
        this.c.value = {};
      }
    }
  }
  @Prop()
  private source: any; //dialog,审核修改弹框;renkouxue,人口学和受试者信息;
  private getOption(key: any) {
    return getOptions(key);
  }
  private mounted() {
    this.templateIndex = this.index;
  }
}
